import { resolveDynamicLines, totalMonthly, totalYearly } from "@/utils/estimate";

export const getters = {
  // Support plans are priced off everything else, so the resolved list -- not
  // the raw state -- is what the UI must read.
  addedServices: (state) => resolveDynamicLines(state.addedServices),
  rawServices: (state) => state.addedServices,
  groups: (state) => state.groups,
  exchangeRates: (state) => state.exchangeRates,
  currentCurrency: (state) => state.currentCurrency,

  totalMonthlyCost: (state, getters) => totalMonthly(getters.addedServices),
  totalYearlyCost: (state, getters) => totalYearly(getters.addedServices),
  serviceById: (state, getters) => (id) =>
    getters.addedServices.find((service) => service.id === id),

  /** Group totals follow the live line prices, not the copy taken at add time. */
  groupsWithTotals: (state, getters) =>
    state.groups.map((group) => {
      const services = (group.services || [])
        .map((entry) =>
          getters.addedServices.find((line) => line.id === entry.id)
        )
        .filter(Boolean);

      return {
        ...group,
        services,
        totalMonthlyCost: totalMonthly(services),
      };
    }),
};
